(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtu-product-compare"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-xtu-product-compare]');

    roots.forEach((root) => {
      if (root.dataset.xtuPcReady === 'true') return;
      root.dataset.xtuPcReady = 'true';

      const scroller = root.querySelector('[data-xtu-pc-scroller]');
      if (!scroller) return;

      const sync = () => {
        root.classList.toggle('is-scrolled', scroller.scrollLeft > 2);
      };

      scroller.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtu-product-specs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-xtu-product-specs]');

    roots.forEach((root) => {
      if (root.dataset.xtuPsReady === 'true') return;
      root.dataset.xtuPsReady = 'true';

      const toggle = root.querySelector('[data-xtu-ps-toggle]');
      if (!toggle) return;

      const labelEl = toggle.querySelector('[data-xtu-ps-toggle-label]');
      const items = root.querySelectorAll('[data-xtu-ps-item].is-collapsed');
      const more = toggle.dataset.labelMore || 'View More';
      const less = toggle.dataset.labelLess || 'View Less';

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const next = !expanded;
        toggle.setAttribute('aria-expanded', String(next));
        if (labelEl) labelEl.textContent = next ? less : more;

        items.forEach((item) => {
          if (next) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtu-tab-images"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-xtu-tab-images]');

    const playVideo = (video) => {
      if (!(video instanceof HTMLVideoElement)) return;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const pauseVideo = (video) => {
      if (!(video instanceof HTMLVideoElement)) return;
      video.pause();
    };

    const syncPanelVideos = (panel, active, interacted) => {
      panel.querySelectorAll('video').forEach((video) => {
        if (!active) {
          pauseVideo(video);
        } else if (video.hasAttribute('data-xtu-deferred-media')) {
          if (interacted) window.XtuDeferredMedia?.activate(video, { play: true });
        } else {
          playVideo(video);
        }
      });
    };

    const scrollTabToEdge = (tab, edge) => {
      const list = tab.closest('.xtu-tab-images__tabs');
      if (!(list instanceof HTMLElement)) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const styles = getComputedStyle(list);
      const padStart = parseFloat(styles.paddingInlineStart) || 0;
      const padEnd = parseFloat(styles.paddingInlineEnd) || 0;
      const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      const tabsInList = Array.from(list.querySelectorAll('[data-xtu-ti-tab]'));
      const isFirst = tabsInList[0] === tab;
      const isLast = tabsInList[tabsInList.length - 1] === tab;

      let targetLeft = 0;
      if (edge === 'end') {
        if (isLast) {
          targetLeft = maxScroll;
        } else {
          targetLeft = tab.offsetLeft + tab.offsetWidth - list.clientWidth + padEnd;
        }
      } else if (!isFirst) {
        targetLeft = tab.offsetLeft - padStart;
      }

      targetLeft = Math.max(0, Math.min(targetLeft, maxScroll));

      list.scrollTo({
        left: targetLeft,
        behavior: reduced ? 'auto' : 'smooth',
      });
    };

    roots.forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.xtuTiReady === 'true') return;
      root.dataset.xtuTiReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-xtu-ti-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-xtu-ti-panel]'));
      const tabList = root.querySelector('.xtu-tab-images__tabs');
      if (!tabs.length) return;

      let activeIndex = Math.max(
        0,
        tabs.findIndex((tab) => tab.classList.contains('is-active'))
      );

      let touchStartX = null;
      let touchStartY = null;

      if (tabList instanceof HTMLElement) {
        tabList.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1) return;
            touchStartX = event.touches[0].clientX;
            touchStartY = event.touches[0].clientY;
          },
          { passive: true }
        );

        tabList.addEventListener(
          'touchmove',
          (event) => {
            if (touchStartX == null || touchStartY == null || event.touches.length !== 1) return;
            const dx = Math.abs(event.touches[0].clientX - touchStartX);
            const dy = Math.abs(event.touches[0].clientY - touchStartY);
            if (dx > dy && dx > 4) {
              event.stopPropagation();
            }
          },
          { passive: true }
        );

        tabList.addEventListener(
          'touchend',
          () => {
            touchStartX = null;
            touchStartY = null;
          },
          { passive: true }
        );
      }

      const activate = (index, options = {}) => {
        const prevIndex = activeIndex;
        tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });

        panels.forEach((panel, i) => {
          const on = i === index;
          panel.classList.toggle('is-active', on);
          if (on) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
          syncPanelVideos(panel, on, !options.skipScroll);
        });

        activeIndex = index;

        if (options.skipScroll) return;

        const activeTab = tabs[index];
        if (!(activeTab instanceof HTMLElement)) return;

        let edge = index < prevIndex ? 'end' : 'start';
        if (prevIndex === tabs.length - 1 && index === 0) edge = 'start';
        if (prevIndex === 0 && index === tabs.length - 1) edge = 'end';
        scrollTabToEdge(activeTab, edge);
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));

        tab.addEventListener('keydown', (event) => {
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = tabs.length - 1;
          }
          if (next === null) return;
          event.preventDefault();
          activate(next);
          tabs[next].focus();
        });
      });

      activate(activeIndex, { skipScroll: true });
      const initialTab = tabs[activeIndex];
      if (initialTab instanceof HTMLElement) {
        scrollTabToEdge(initialTab, 'start');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
